<template>
  <div
    :class="
      `chat-message tw-pt-4 tw-flex tw-gap-2 ${
        reverse ? 'tw-flex-row-reverse' : 'tw-flex-row'
      }`
    "
  >
    <div
      class="
        tw-flex-none tw-justify-center tw-items-center
        icon
        tw-p-2 tw-h-fit tw-w-min tw-rounded-full
      "
      :class="
        `${reverse ? 'tw-bg-slate-200 tw-drop-shadow-sm' : 'tw-bg-slate-200'}`
      "
    >
      <svg
        v-if="reverse"
        class="tw-w-5 tw-h-5"
        viewBox="0 0 50 28"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <title>mobile</title>
        <desc>Created with Sketch.</desc>
        <defs></defs>
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="mobile">
            <path
              d="M29.3980392,0.0965 C27.2504902,0.0965 25.7686275,1.4815 24.8519608,3.407 L18.8186275,16.385 L18.8107843,16.3655 L18.8068627,16.3735 L18.8034314,16.3655 L18.7931373,16.385 L12.7607843,3.4075 C11.845098,1.4815 10.3632353,0.097 8.21617647,0.097 L0.600980392,0.097 C0.324509804,0.097 0.0965686275,0.328 0.0965686275,0.611 C0.0965686275,0.8935 0.32254902,1.125 0.600980392,1.125 L0.866176471,1.125 L1.10294118,1.125 C2.19656863,1.156 3.13088235,1.699 3.92696078,3.407 L14.3308824,25.7135 C13.9122549,26.2205 13.3671569,26.5205 12.4338235,26.599 L11.3642157,26.599 C11.0867647,26.599 10.8598039,26.831 10.8598039,27.1135 C10.8598039,27.3975 11.0867647,27.6295 11.3642157,27.6295 L19.3544118,27.6295 C21.8602941,27.6415 23.4553922,25.3875 24.4098039,23.3385 L33.6857843,3.407 C34.4813725,1.698 35.4166667,1.156 36.5117647,1.125 L36.7470588,1.125 L37.0127451,1.125 C37.2901961,1.125 37.5176471,0.8935 37.5176471,0.611 C37.5176471,0.328 37.2901961,0.097 37.0127451,0.097 L29.3980392,0.097 L29.3980392,0.0965 Z"
              id="Shape"
              fill="#2D2B74"
            ></path>
            <path
              d="M41.0843137,0.0965 C38.9323529,0.0965 37.4558824,1.198 36.5397059,3.124 L26.3357843,23.939 C25.5343137,25.5755 25.127451,26.599 23.147549,26.599 C22.4813725,26.599 22.4813725,27.627 23.147549,27.63 L35.9637255,27.63 C42.5392157,27.6485 46.3323529,23.675 46.979902,18.839 C47.1779412,17.3615 47.0122549,16.886 45.6529412,18.0845 C43.3696078,20.0995 40.3691176,21.6135 38.4387255,21.7655 C37.5093137,21.8385 37.804902,21.217 38.0421569,20.707 L46.095098,3.407 C46.720098,2.0625 47.5759804,1.125 49.0843137,1.125 C49.7514706,1.125 49.7504902,0.101 49.0843137,0.0965 L41.0843137,0.0965 L41.0843137,0.0965 Z M18.8073529,0.0965 C21.0735294,0.0965 22.9107843,1.9715 22.9107843,4.2815 C22.9107843,6.5945 21.0735294,8.4695 18.8073529,8.4695 C16.5401961,8.4695 14.7019608,6.5945 14.7019608,4.2815 C14.7019608,1.9715 16.5401961,0.0965 18.8073529,0.0965 L18.8073529,0.0965 Z"
              id="Shape"
              fill="#C72127"
            ></path>
          </g>
        </g>
      </svg>
      <div class="tw-text-white tw-font-bold tw-w-5 tw-h-5 tw-uppercase" v-else>
        {{ senderName[0] }}
      </div>
    </div>
    <div class="tw-flex tw-items-start tw-gap-1 tw-relative" v-if="message.Type === 'text'">
      <!-- Menu button on the left -->
      <div v-if="canUnsend" class="tw-relative message-menu">
        <button
          @click.stop="toggleMenu"
          class="
            tw-flex-none
            tw-w-5
            tw-h-5
            tw-mt-2
            tw-rounded-full
            tw-flex
            tw-items-center
            tw-justify-center
            tw-text-gray-400
            hover:tw-text-primary
            hover:tw-bg-gray-100
            tw-transition-colors
          "
          :class="{ 'tw-bg-gray-100 tw-text-primary': showMenu }"
          title="Message options"
        >
          <svg
            class="tw-w-3 tw-h-3"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            fill="currentColor"
          >
            <path
              d="M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
            />
          </svg>
        </button>
        <!-- Dropdown Menu -->
        <div
          v-if="showMenu"
          class="
            tw-absolute
            tw-left-6
            tw-top-0
            tw-bg-white
            tw-shadow-lg
            tw-rounded-lg
            tw-border
            tw-border-gray-200
            tw-z-50
            tw-overflow-hidden
            tw-min-w-[120px]
          "
        >
          <button
            @click.stop="unsendMessage"
            class="
              tw-w-full
              tw-px-4
              tw-py-2
              tw-text-left
              tw-text-sm
              tw-text-red-600
              hover:tw-bg-red-50
              tw-flex
              tw-items-center
              tw-gap-2
              tw-whitespace-nowrap
            "
          >
            <svg
              class="tw-w-4 tw-h-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              fill="currentColor"
            >
              <path
                d="M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"
              />
            </svg>
            Unsend
          </button>
        </div>
      </div>
      <div
        class="
          message
          tw-flex
          tw-max-w-[20rem]
          tw-h-fit
          tw-py-2
          tw-text-left
          tw-items-center
          tw-relative
          tw-px-4
          tw-rounded-lg
        "
        :class="
          `${
            reverse
              ? `tw-bg-${messageColor.bg} tw-text-${messageColor.text}`
              : 'tw-bg-white tw-border tw-border-gray-200'
          } ${showTimestamp ? 'tw-mb-4' : ''}`
        "
        @click="handleClick"
      >
        <div
          class="
            tw-absolute tw--top-5 tw-text-xs tw-text-gray-400 tw-whitespace-nowrap
          "
          :class="{
            'tw-right-0': reverse,
            'tw-left-0': !reverse,
          }"
        >
          {{ senderName.split(" ")[0] }}
        </div>
        <p class="tw-whitespace-pre-wrap">{{ message.Text }}</p>
        <p
          v-if="showTimestamp"
          class="
            tw-text-xs
            tw-text-slate-700
            tw-absolute
            tw--bottom-5
            tw-whitespace-nowrap
          "
          :class="reverse ? 'tw-right-0' : 'tw-left-0'"
        >
          {{ message.CreatedAt | formatedTimestamp }}
        </p>
      </div>
    </div>
    <div class="tw-flex tw-items-start tw-gap-1 tw-relative" v-if="message.Type === 'image'">
      <!-- Menu button on the left -->
      <div v-if="canUnsend" class="tw-relative message-menu">
        <button
          @click.stop="toggleMenu"
          class="
            tw-flex-none
            tw-w-5
            tw-h-5
            tw-mt-2
            tw-rounded-full
            tw-flex
            tw-items-center
            tw-justify-center
            tw-text-gray-400
            hover:tw-text-primary
            hover:tw-bg-gray-100
            tw-transition-colors
          "
          :class="{ 'tw-bg-gray-100 tw-text-primary': showMenu }"
          title="Message options"
        >
          <svg
            class="tw-w-3 tw-h-3"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            fill="currentColor"
          >
            <path
              d="M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
            />
          </svg>
        </button>
        <!-- Dropdown Menu -->
        <div
          v-if="showMenu"
          class="
            tw-absolute
            tw-left-6
            tw-top-0
            tw-bg-white
            tw-shadow-lg
            tw-rounded-lg
            tw-border
            tw-border-gray-200
            tw-z-50
            tw-overflow-hidden
            tw-min-w-[120px]
          "
        >
          <button
            @click.stop="unsendMessage"
            class="
              tw-w-full
              tw-px-4
              tw-py-2
              tw-text-left
              tw-text-sm
              tw-text-red-600
              hover:tw-bg-red-50
              tw-flex
              tw-items-center
              tw-gap-2
              tw-whitespace-nowrap
            "
          >
            <svg
              class="tw-w-4 tw-h-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              fill="currentColor"
            >
              <path
                d="M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"
              />
            </svg>
            Unsend
          </button>
        </div>
      </div>
      <div
        class="
          message
          tw-flex
          tw-max-w-[20rem]
          tw-h-fit
          tw-p-2
          tw-text-left
          tw-items-center
          tw-relative
          tw-rounded-lg
          tw-text-slate-800
          tw-shadow-sm
          tw-drop-shadow-sm
          tw-border
        "
        :class="
          `${
            reverse
              ? `tw-bg-${messageColor.bg} tw-text-${messageColor.text}`
              : 'tw-bg-white'
          } ${showTimestamp ? 'tw-mb-4' : ''}`
        "
        @click="handleClick"
      >
        <div
          class="
            tw-absolute tw--top-5 tw-text-xs tw-text-gray-400 tw-whitespace-nowrap
          "
          :class="{
            'tw-right-0': reverse,
            'tw-left-0': !reverse,
          }"
        >
          {{ senderName.split(" ")[0] }}
        </div>
        <img class="tw-w-full" :src="imageURL" alt="chat img" />
        <p
          v-if="showTimestamp"
          class="
            tw-text-xs
            tw-text-slate-700
            tw-absolute
            tw--bottom-5
            tw-whitespace-nowrap
          "
          :class="reverse ? 'tw-right-0' : 'tw-left-0'"
        >
          {{ message.CreatedAt | formatedTimestamp }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
dayjs.extend(localizedFormat);

export default {
  name: "ChatMessage",
  props: ["message"],
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  data() {
    return {
      showTimestamp: false,
      imageURL: null,
      messageColor: {
        text: "white",
        bg: "primary",
      },
      showMenu: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "userInfo",
      decoded: "chat/decoded",
      agents: "chat/agents",
      channel: "chat/channel",
      room: "chat/room",
    }),
    // senderID() {
    //   if (this.user) {
    //     return this.user.attributes.sub;
    //   }
    //   return null;
    // },
    participants() {
      if (this.channel === "background") {
        return this.room.BackgroundChannel.Participants;
      }
      return this.room.MainChannel.Participants;
    },
    senderName() {
      const senderName = this.participants.find(
        (p) => p.ID === this.message.SenderID
      )?.Name;
      if (senderName) {
        return senderName;
      } else if (this.message.SenderInfo?.Name) {
        return this.message.SenderInfo?.Name;
      }
      return "Unknown";
    },
    reverse() {
      if (this.channel === "main") {
        const agent = this.agents.find(
          (a) => a.AgentID === this.message.SenderID
        );
        if (agent) {
          return true;
        }
      }
      return this.message?.SenderID === this.user.userCode;
    },
    canUnsend() {
      return this.reverse;
    },
  },
  watch: {
    message: {
      immediate: true,
      handler: async function () {
        // console.log(this.message);
        if (this.message.Type === "image") {
          //Preview type
          if (this.message.imageSrc) {
            this.imageURL = this.message.imageSrc;
            return;
          }
          this.imageURL = await this.$store.dispatch(
            "chat/getImageURL",
            this.message.File
          );
          return;
        }
        this.imageURL = null;
      },
    },
  },
  methods: {
    handleClick() {
      this.showTimestamp = !this.showTimestamp;
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    handleClickOutside(event) {
      const target = event.target;
      if (this.showMenu && !target.closest(".message-menu")) {
        this.showMenu = false;
      }
    },
    async unsendMessage() {
      this.showMenu = false;
      if (!confirm("Are you sure you want to unsend this message?")) {
        return;
      }
      try {
        await this.$store.dispatch("chat/unsendMessage", {
          Attributes: this.message.Attributes,
        });
      } catch (error) {
        console.error("Failed to unsend message:", error);
        alert("Failed to unsend message. Please try again.");
      }
    },
  },
  filters: {
    formatedTimestamp(timestamp) {
      if (dayjs(timestamp).isSame(dayjs(), "day")) {
        return dayjs(timestamp).format("LT");
      }
      return dayjs(timestamp).format("llll");
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0;
}
</style>
